/**
 * from: https://usehooks.com/useRequireAuth/
 */
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { getLogger } from '../util/logger';
import { useAuth } from '../components/hooks/useAuth';
import routerPaths from '../components/util/routerPaths';

const logger = getLogger('useRequireAuth');

const useRequireAuth = (redirectUrl = routerPaths.LOGIN) => {
  const auth = useAuth();
  const history = useHistory();

  // If auth.tenant is false that means we're not
  // logged in and should redirect.
  useEffect(() => {
    if (
      !auth.loading &&
      !auth.isLoggedIn &&
      !new URLSearchParams(history.location.search).has('error') // don't redirect if we are told to report an error
    ) {
      logger.debug(`'userRequireAuth redirecting to ${redirectUrl}`);
      history.push({
        pathname: redirectUrl,
        state: { from: history.location },
      });
    }
  }, [auth, history, redirectUrl]);

  return auth;
};

export default useRequireAuth;
